export const TYPE_LABELS = {
  image: 'صورة',
  video: 'فيديو',
  audio: 'صوت',
  document: 'ملف',
  other: 'أخرى'
};

export const LESSON_LIBRARY = [
  {
    id: 'lesson-1',
    title: 'الدرس الأول: الموارد المعدنية',
    description: 'ملفات تدعم شرح الذهب والفوسفات والحديد والنحاس وأماكن وجودها.',
    categories: ['الدرسالاول الجديد'],
    includeKeywords: ['ذهب', 'السكري', 'فوسفات', 'أبو', 'طرطور', 'حديد', 'نحاس', 'منجم', 'التعدين']
  },
  {
    id: 'lesson-2',
    title: 'الدرس الثاني: مصادر الطاقة',
    description: 'ملفات تدعم شرح الغاز والبترول والطاقة الكهربائية والمتجددة.',
    categories: ['الدرس الثانى الجديد'],
    includeKeywords: ['طاقة', 'غاز', 'حقل', 'كهرب', 'شمسي', 'رياح', 'بترول']
  },
  {
    id: 'lesson-3',
    title: 'الدرس الثالث: المياه والزراعة',
    description: 'ملفات تدعم شرح المياه والري والأراضي الزراعية والمحاصيل.',
    categories: ['الدرس الثانى الجديد', 'الخلفيات'],
    includeKeywords: ['مياه', 'زراعة', 'الأراضي', 'الأرض', 'محاصيل', 'دلتا', 'النيل', 'ري', 'مالحة', 'عذبة']
  }
];

export const CATEGORY_META = {
  root: {
    title: 'ملفات عامة',
    description: 'محتوى أساسي متاح للاستخدام داخل المنصة.'
  },
  'اشكال جيدة لل presentation': {
    title: 'أشكال للعرض التقديمي',
    description: 'صور وأشكال جاهزة تضيف لمسة بصرية قوية للعروض التقديمية.'
  },
  'اشكال للروبوتات والشات جى بى تى': {
    title: 'أشكال روبوتات وذكاء اصطناعي',
    description: 'أيقونات وشخصيات وروبوتات للاستخدام في الواجهات والشرح.'
  },
  'الخلفيات': {
    title: 'الخلفيات',
    description: 'خلفيات جاهزة لمشاهد ودروس متنوعة عن مصر.'
  },
  'الدرس الثانى الجديد': {
    title: 'ملفات الدرس الثاني',
    description: 'صور وملفات داعمة لموضوعات المياه والطاقة.'
  },
  'الدرسالاول الجديد': {
    title: 'ملفات الدرس الأول',
    description: 'صور وملفات داعمة لموضوعات الموارد المعدنية والطاقة.'
  }
};
